import {classNames, layout, TabBar, TabItem, View, ViewContent} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {style, stylesheet} from "typestyle";
import {CubeOrder, Shop} from "../types";
import {OrderTab} from "./OrderTab";
import {BoxTab} from "./BoxTab";
import {useLocalization} from "../../i18n";

interface ShopAccessHomeProps {
    shop: Shop;
    active: ShopHomeTab;
    onTabActivated: (tab: ShopHomeTab) => void;
    onOpen: (cubeOrder: CubeOrder) => void;
    onDone: () => void;
    allowOpenNonOccupied: boolean;
}

export enum ShopHomeTab {
    Orders = "Orders",
    Delivery = "Deliver",
    Pickup = "Pickup",
    Boxes = "Boxes"
}

const doneButtonStyle = style({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0.25rem 0.75rem",
    background: "var(--color-primary)",
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "1.25em",
});

export function ShopAccessHome(props: ShopAccessHomeProps) {
    const {
        active,
        shop,
        onOpen,
        onTabActivated,
        onDone,
        allowOpenNonOccupied
    } = props;

    const {t} = useLocalization();

    const handleOrdersClick = useCallback(() => onTabActivated(ShopHomeTab.Orders), [onTabActivated]);
    const handleBoxesClick = useCallback(() => onTabActivated(ShopHomeTab.Boxes), [onTabActivated]);

    const renderTabContent = useCallback(() => {
        switch (active) {
            case ShopHomeTab.Orders:
                return <OrderTab shop={shop} onOpen={onOpen}/>;
            case ShopHomeTab.Boxes:
                return <BoxTab shop={shop} allowOpenNonOccupied={allowOpenNonOccupied}/>;
        }
    }, [active, shop]);

    return (
        <View className={layout.vertical}>
            <div className={classNames(layout.fixed, layout.horizontal)}>
                <TabBar className={layout.fill}>
                    <TabItem active={active == ShopHomeTab.Orders} onClick={handleOrdersClick}>
                        {t("Orders")}
                    </TabItem>
                    <TabItem active={active == ShopHomeTab.Boxes} onClick={handleBoxesClick}>
                        {t("Boxes")}
                    </TabItem>
                </TabBar>
                <div className={doneButtonStyle} onClick={onDone}>
                    <div>{t("Logout")}</div>
                </div>
            </div>
            <ViewContent className={styles.tabContent}>
                {renderTabContent()}
            </ViewContent>
        </View>
    );
}


const styles = stylesheet({
    tabContent: {
        padding: "0.75em",
        backgroundColor: "#fff"
    }
});
